import ReqClient from './request.class'

// 获取媒体分页列表
export async function queryMedia (params) {
  const Req = new ReqClient({
    url: '/api/ptom/media/page',
    method: 'POST',
    data: params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 添加媒体信息
export async function addMedia (params) {
  const Req = new ReqClient({
    url: '/api/ptom/media/add',
    method: 'POST',
    data: params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新媒体信息
export async function updateMedia (params) {
  const Req = new ReqClient({
    url: '/api/ptom/media/update',
    method: 'POST',
    data: params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取媒体广告位分页列表
export async function queryAdvPosition (params) {
  const Req = new ReqClient({
    url: '/api/ptom/media/queryAdvPosition',
    method: 'POST',
    data: params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 添加媒体广告位信息
export async function addAdvert (params) {
  const Req = new ReqClient({
    url: '/api/ptom/media/addAdvert',
    method: 'POST',
    data: params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新媒体广告位信息
export async function updateAdvert (params) {
  const Req = new ReqClient({
    url: '/api/ptom/media/updateAdvert',
    method: 'POST',
    data: params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 删除媒体广告位
export async function deleteAdvert (params) {
  const Req = new ReqClient({
    url: '/api/ptom/media/deleteAdvert',
    method: 'POST',
    data: params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 启用禁用媒体
export async function changeMediaStatus (params) {
  const Req = new ReqClient({
    url: '/api/ptom/media/operate',
    method: 'POST',
    data: params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
